import type { TrainerFlags } from './trainers';

export enum HostType {
    APP = 'app',
    WEB = 'web',
    REMOTE = 'remote',
    OVERLAY = 'overlay',
}

export enum HostMode {
    MODAL = 'modal',
    EMBED = 'embed',
    WINDOW = 'window',
    PRELOAD = 'preload',
}

export enum RpcType {
    PARENT = 'parent',
    SELF = 'self',
    OPENER = 'opener',
    WEBVIEW = 'webview',
    NONE = 'none',
}

export interface HostSettings {
    readonly theme?: string;
    readonly useWindowsContrastMode?: boolean;
    readonly reduceMotion?: boolean;
}

export interface HostInfo {
    readonly type: HostType;
    readonly mode: HostMode;
    readonly rpc: RpcType;
    readonly origin?: string;
    readonly settings: HostSettings;
}
export interface DeviceInfo {
    readonly type: 'mobile' | 'desktop' | undefined;
    readonly os: 'windows' | 'macos' | undefined;
}

export interface WebviewOpenResult {
    readonly ok: boolean;
    readonly output?: unknown;
}

export interface SimpleToastMessage {
    readonly content: string;
    readonly type?: 'alert' | 'ok' | 'boost' | 'arrow-up' | 'arrow-down' | 'warning' | 'tada';
}

export interface EventDispatch {
    readonly ga?: boolean;
    readonly amplitude?: boolean;
}

export interface CurrentTrainerInfo {
    readonly titleId: string;
    readonly flags: TrainerFlags;
}

export const EVENT_DISPATCH_ALL: EventDispatch = {
    ga: true,
    amplitude: true,
};

export interface CurrentTrainerInfo {
    readonly titleId: string;
    readonly flags: TrainerFlags;
}

export interface SwitchGameMapConfig {
    readonly mapId: string;
}

export type ExternalIdSwitchGameMapConfig = Omit<SwitchGameMapConfig, 'mapId'> & { externalId: string };

export interface GuideDataConfig {
    readonly guide: string;
    readonly data: object;
}
